import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PartialId } from '@attain-apps/string-builder'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as messageInfo from './message-info'

export const DOC = gql`
  ${messageInfo.DOC}
  fragment FragmentAgentChatMessage on AgentChatMessage {
    id
    role
    conversationId
    createdAt
    info {
      ...FragmentAgentChatMessageInfo
    }
    status
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentAgentChatMessageFragment,
  ents.core.agent.Message.WithInfo
>({
  conversationId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
  createdAt: graphql.transformers.OUT.validate(
    graphql.transformers.AWS_SCALARS.datetime,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    PartialId.assertIsPartialId,
  ),
  info: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(messageInfo.TRANSFORMER, {
      onNullish: 'remove',
    }),
    [],
  ),
  role: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.enumeration<
      graphql.schema.AgentMessageRole,
      ents.core.agent.Message.Role
    >({
      [graphql.schema.AgentMessageRole.Agent]: 'agent',
      [graphql.schema.AgentMessageRole.User]: 'user',
    }),
    TypeAsserter.assertIsNotNullish,
  ),
  status: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.enumeration<
      graphql.schema.AgentMessageStatus,
      ents.core.agent.Message.Status
    >({
      [graphql.schema.AgentMessageStatus.Completed]: 'completed',
      [graphql.schema.AgentMessageStatus.Failed]: 'failed',
      [graphql.schema.AgentMessageStatus.Pending]: 'pending',
    }),
    TypeAsserter.assertIsNotNullish,
  ),
})
